import { authPut, getAuthBaseURL } from "./auth";

export const refreshIdentity = (): Promise<{ token: string }> =>
  authPut<Record<string, never>, { token: string }>(
    `${getAuthBaseURL()}/refresh`,
    {}
  );
